import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './modalui.css';
import {useTranslation} from "../../../../hooks/useTranslation";

const ModalInstructions = (props) => {
    const [show, setShow] = useState(false);
    const {t} = useTranslation();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { title, content } = props.data || {};

    const renderContent = () => {
        if (React.isValidElement(content)) return content;
        if (typeof content === 'string' || typeof content === 'number') return <div dangerouslySetInnerHTML={{ __html: String(content) }} />;

        return content || null;
    }

    return (
        <React.Fragment>
            <i
                onClick={handleShow}
                className="fas fa-question-circle mr-5 ml-2 text-primary modalTriggerIcon"
            ></i>
            <Modal className="themeModal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {renderContent()}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleClose}>
                        {t("basicModal.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

export default ModalInstructions;